"use client";

import Lottie from "react-lottie";
import loaderAnimation from "./loader.json";

interface LoadingLottieProps {
  width?: number;
  height?: number;
}

export const LoadingLottie = ({ width = 24, height = 24 }: LoadingLottieProps) => {
  const animationOptions = {
    loop: true,
    autoplay: true,
    animationData: loaderAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return <Lottie options={animationOptions} height={height} width={width} />;
};
